

import { async } from '@angular/core/testing';
import { SocketioService } from './../../../services/socketio.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { UsuarioService } from './../../../services/usuario/usuario.service';
import { Usuario } from './../../../models/usuario';
import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material';
import { CapturaComponent } from '../captura/captura.component';
import { CapturalanderComponent } from '../capturalander/capturalander.component';
import { NuevousuarioComponent } from '../nuevousuario/nuevousuario.component';

@Component({
  selector: 'app-usuarioslander',
  templateUrl: './usuarioslander.component.html',
  styleUrls: ['./usuarioslander.component.css']
})
export class UsuarioslanderComponent implements OnInit, OnDestroy {
  usuariolistado: Usuario[] = [];
  idempresa: string;
  sus: any;
  sususuarios: any;

 selectedValue = null;

  constructor(
    public usuarioService: UsuarioService,
    private dialog: MatDialog,
    public socketioService: SocketioService
  ) { }

  ngOnInit() {

    this.sus = this.socketioService.listen ('actualizausuarios').subscribe (resp => {
      this.Listadousuarios();
      });





    this.idempresa = this.usuarioService.idempresa;
    this.Listadousuarios();
  }

  ngOnDestroy() {
    console.log ('OnDestroy ON');
    this.sus.unsubscribe();
    this.sususuarios.unsubscribe();
  }


  async Listadousuarios() {

    this.sususuarios = await this.usuarioService.listadototalusuariosxempresa(this.idempresa)
    .subscribe ( resp => {
        this.usuariolistado = resp;
    });
  }


  crearnuevousuario() {
    localStorage.setItem('new', 'ok');


    const dialogRef = this.dialog.open(NuevousuarioComponent, {panelClass: 'mensaje',
    disableClose: true,

  });



    dialogRef.afterClosed().subscribe(
    data => {
      this.socketioService.emit('actualizausuarios',
      {actualiza: true});


    }
  );

  }



  editarusuarios(listado: Usuario) {

    const dialogRef = this.dialog.open(CapturalanderComponent, {panelClass: 'mensaje',
      disableClose: true,
      data: {
       identificador: listado
      }
    });



    dialogRef.afterClosed().subscribe(
      data => {
        this.socketioService.emit('actualizausuarios',
        {actualiza: true});


      }
    );






  }



  nuevousuario(listado: Usuario) {

    const dialogRef = this.dialog.open(CapturalanderComponent, {panelClass: 'mensaje',
      disableClose: true,
      data: {
       identificador: listado
      }
    });



    dialogRef.afterClosed().subscribe(
      data => {
        this.socketioService.emit('actualizausuarios',
        {actualiza: true});


      }
    );






  }




}
